export const SelectStyles = {
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: '#B9B9C3'
      };
    },
    multiValue: (styles) => {
      return {
        ...styles,
        backgroundColor: '#5096F4'
      };
    },
    multiValueLabel: (styles) => {
      return {
        ...styles,
        color: 'white'
      };
    },
    multiValueRemove: (styles) => {
      return {
        ...styles,
        color: 'white'
      };
    },
    indicatorSeparator: (styles) => {
      return {
        ...styles,
        display: 'none'
      };
    },
    menu: (styles) => {
      return {
        ...styles,
        zIndex: 1000,
        minWidth: "180px"
      };
    },
    container: (styles) => {
      return {
        ...styles,
        minWidth: '100%',
        maxWidth: '400px',
        width: "100%"
      };
    },
    control: (styles, state) => {
      return {
        ...styles,
        boxShadow: state.isFocused && "0 3px 10px 0 rgba(34, 41, 47, 0.1)",
        border: state.isFocused ? "1px solid #00BA62" : "1px solid #d8d6de",
        "&:hover": {
          border: state.isFocused && "1px solid #00BA62"
        },
        backgroundColor: state.isFocused && "transparent"
      }
    }
};